<template>
  <div>
    <h6 class="title-section no_desktop">{{$t('navbar.subtitulo')}}</h6>
    <div class="steps">
      <div class="step" :class="{ active: tabIndex == 0 , off: 0 < tabIndex}">
        <span>1</span>
        <p>{{$t('planesYPrecios.pasos.1')}}</p>
      </div>
      <div class="step" :class="{ active: tabIndex == 1 , off: 1 < tabIndex}">
        <span>2</span>
        <p>{{$t('planesYPrecios.pasos.2')}}</p>
      </div>
      <div class="step" :class="{ active: tabIndex == 2 , off: 2 < tabIndex}">
        <span>3</span>
        <p>{{$t('planesYPrecios.pasos.3')}}</p>
      </div>
      <div class="step" :class="{ active: tabIndex == 3 , off: 3 < tabIndex}">
        <span>4</span>
        <p>{{$t('planesYPrecios.pasos.4')}}</p>
      </div>
      <div class="step" :class="{ active: tabIndex == 4 , off: 4 < tabIndex}">
        <span>5</span>
        <p>{{$t('planesYPrecios.pasos.5')}}</p>
      </div>
    </div>
    <b-tabs v-model="tabIndex"  class="cursos-steps-content">
      <b-tab lazy>
		    <SelectPlan :next-step="nextStep"  :group-person-data="group.groupPerson"  @listenChild="selectPlanValueChild"/>
	    </b-tab>
      <b-tab lazy>
        <Objetivo  :next-step="nextStep" :back-step="backStep" :goals="lists.goals" :student-data="group.groupPerson.personStudent" :goal-data="group.groupPerson.personStudent.goalSelected" :exam-data="group.groupPerson.personStudent.examSelected" @listenChild="objectiveValueChild"/>
      </b-tab>
      <b-tab lazy>
        <Evaluacion :next-step="nextStep" :back-step="backStep" :levels="lists.levels"  :flagEvalGroup="group.flagGroup" :receivedValue="evaluationValueReceived" @listenChild="evaluationValueChild" @listenLevel="evaluationLevelChild" />
      </b-tab>
      <b-tab lazy>
		    <Cursos :next-step="nextStep" :back-step="backStep" :goals="lists.goals" :levels="lists.levels" :group-data="group" :receivedValue="courseValueReceived" @listenChild="courseValueChild" @listenChildGoal="objectiveValueChild" @listenChildPlan="selectPlanValueChildModal" :flag-gestionar-cursos="false" :flag-show-buttons="true"/>
      </b-tab>
        <b-tab lazy>
		    <Compras :next-step="nextStep" :back-step="backStep" :goals="lists.goals" :levels="lists.levels" :group-data="group" :receivedValue="courseValueReceived" @listenChild="courseValueChild" @listenChildGoal="objectiveValueChild" @listenChildPlan="selectPlanValueChild"/>
      </b-tab>
    </b-tabs> 
  </div>
</template>

<script>
// function prueba(){
//   debugger;
  // if(this.tabIndex!=0){
  //   }
  // }
// prueba()
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import SelectPlan from './select-plan'
import Objetivo from './objetivo'
import Evaluacion from './evaluacion'
import Cursos from './cursos'
import Compras from './compras'
import { mapMutations, mapState } from 'vuex';
import store from "../../store"


export default {
  components:{
    SelectPlan,
    Objetivo,
    Evaluacion,
    Cursos,
    Compras 
  },
  data(){

	return{
      lang:localStorage.getItem('lang') || 'es',
      API_URL: process.env.VUE_APP_API_URL,
      tabIndex: 0,
      evaluationValueReceived: {
        personStudentId: 0,
        level:{id:0}
      },
      courseValueReceived: null,
      group: {
        id: 0,
        groupPerson: {
          groupPersonId: 0,
          planTypeId: 0,
          personStudent: {
            id: 0,
            courseId: 0,
            levelId: 0,
            age:0,
            planPreviousTypeId:0,
            planSelected:{
                typeId:0,
                id:0,
		            planPriceId : 0,
                planPriceTypeId:0,
                type :{
                  code : '',
                  name : '',
                  value : ''
                },
                name : '',
                description : '',
                tooltip : '',
                price : 0.00,
                duration : 0
            },
            goalSelected:{
                type:0,
                id:0,
            },
            examSelected:{
               name: '',
               id: 0,
               programId: 0
            }         
          },
          groupPersonEvaluation: {
              evaluationId: 0,
              evaluation: {
					 	 	 	id:0,
           	 	 	name:'',
           	 	 	duration:0,
							}	 ,
              duration: 0,
              timeDuration:'00:00:00',
              score: 0,
              questionAnswerSelected: []
          }
        },
        flagGroup: false,
        groupCourses: [] 
      },
    
      lists:{
        goals:[],
        levels:[]
      }
    }
  },
  mounted(){
    // window.onbeforeunload = function() {
    //   return 'are you ready?'
    // }
    if(this.User != null){
      this.getLogin(); 
    } 
    
    this.getGoals();
    this.getLevels();

  },
  created() {
       // debugger;
    // console.log(this.$route.params)
    //console.log(this.$route.params)
    let selectedTabs = parseInt(this.$route.params.step);
    let _transaction = this.$route.params.transaction;
    this.tabIndex = 0;

    if(selectedTabs == 4 && _transaction != null){
      this.tabIndex = selectedTabs;
    }
    
    this.$router.push('/compra/'+this.tabIndex).catch(err => {});
    store.commit('mutateIsAlertWindow', true)

    
  },
  watch:{
    $route (to, from){
        //console.log('watch',this.$route.params.step)
        let selectedTabs = parseInt(this.$route.params.step);
        this.tabIndex = selectedTabs;
        //console.log(to, from);

    }
   
  },
  computed: {
    // ...mapState(['tabIndexPills'])
    ...mapState(['isAlertWindow']),
    UserId: {
      get() {
          return this.$store.state.user_id;
      },
    },
    User: {
      get() {
          return this.$store.state.user;
      },
      set(value) {
          this.$store.commit('mutateUser', value);
      }
    },
    DatosSidebar: {
      get() {
          return this.$store.state.datosSidebar;
      }
    },
  },
  beforeRouteLeave (to, from,next) {
    // debugger;
    if(( (this.tabIndex == 1 ||this.tabIndex == 2 || this.tabIndex == 3)  && this.isAlertWindow) || (this.tabIndex == 4 &&  this.$route.params.transaction == null  && this.isAlertWindow)  ){
      const answer = window.confirm( this.$t('planesYPrecios.alert'))
      if(answer) return next()
      if (!answer) return false
    }
    else return next()
    
  },
  methods:{
    // ...mapMutations(['mutateTabIndex']),
    nextStep() {
      this.tabIndex++;
      // this.$route.params.step = this.tabIndex;
      this.$router.push('/compra/'+this.tabIndex)
    },
    backStep() {
      this.tabIndex--;
      this.$router.push('/compra/'+this.tabIndex)
    },
     
    getLogin: function(){
      //this.group.id = this.$store.state.group_id;
      //this.group.groupPerson.groupPersonId = this.$store.state.group_person_id;
      this.evaluationValueReceived.personStudentId = this.User.personStudentId;
      this.group.groupPerson.personStudent.age = this.User.age;
      this.group.groupPerson.personStudent.id = this.User.personStudentId;
      
      /*baseInstanceAxios
				.get(this.API_URL + `/resources/Groups/GetGroupGoal?idStudent=${this.$store.state.user.personStudentId}`)
				.then(response => {
					if(response.data != null && response.data.entity != null){
						this.group.groupPerson.personStudent.goalSelected = response.data.entity.goal;
						this.group.groupPerson.personStudent.examSelected = response.data.entity.subject;
						
					}
				});
      */
      this.$emit('numberStep',this.tabIndex)
    },
    getGoals: function() {
       
      baseInstanceAxios
        .get(this.API_URL + `/resources/Goals/ListByAge?Age=${this.group.groupPerson.personStudent.age}`)
        .then(response => {
          if(response.data != null && response.data.list != null){
            
            this.lists.goals = response.data.list;
          }
        });
    },
    getLevels: function() {
      let flag = this.lang == 'es' ? true : false;
      baseInstanceAxios
        .get(this.API_URL + `/resources/levelsfeatures/getbylevels?flagLanguage=${flag}`)
        .then(response => {
          if(response.data != null && response.data.list != null){
						this.lists.levels = response.data.list;
			    }
      });
    },
    selectPlanValueChild(data) {
	    this.group.groupPerson.personStudent.planSelected = data.plan;
      this.group.groupPerson.planTypeId = data.planTypeId;
      if (data.planPreviousTypeId != undefined) {
        this.group.groupPerson.personStudent.planPreviousTypeId = data.planPreviousTypeId;
      }
      
      this.group.id = data.groupId;
      this.group.groupPerson.groupPersonId = data.groupPersonId;
      this.group.flagGroup  = data.flagGroup;
      this.group.flagGroupCode = data.flagGroupCode;
    },
    selectPlanValueChildModal(data) {
      //debugger;
	    this.group.groupPerson.personStudent.planSelected = data.plan;
      this.group.groupPerson.planTypeId = data.plan.typeId;
      
    },
    objectiveValueChild(data) {
	    this.group.groupPerson.personStudent.goalSelected = data.goal;
      this.group.groupPerson.personStudent.examSelected = data.exam;
    },
    evaluationLevelChild(level){
      this.group.groupPerson.personStudent.levelId = level.id;
    },
    evaluationValueChild(data) {
       
      this.group.groupPerson.groupPersonEvaluation.questionAnswerSelected = data.listAnswersSelecteds;
      this.group.groupPerson.groupPersonEvaluation.evaluation = data.evaluation;
      this.group.groupPerson.groupPersonEvaluation.timeDuration = data.timeDuration;
      this.group.groupPerson.groupPersonEvaluation.duration = data.duration;
      let exam = null;
      if (this.group.groupPerson.personStudent.examSelected.id > 0) {
       exam = this.group.groupPerson.personStudent.examSelected.id;
      }
      //debugger;
      let evalutionExecute ={
        questionAnswerSelected: data.listAnswersSelecteds,
        groupPersonId: this.group.groupPerson.groupPersonId,
        evaluationId: this.group.groupPerson.groupPersonEvaluation.evaluation.id,
        duration: this.group.groupPerson.groupPersonEvaluation.duration,
        timeDuration: this.group.groupPerson.groupPersonEvaluation.timeDuration,
        goalId:this.group.groupPerson.personStudent.goalSelected.id,
        planPriceId:this.group.groupPerson.personStudent.planSelected.planPriceId,
        typePlanPriceId:this.group.groupPerson.personStudent.planSelected.planPriceTypeId,
        personStudentId:this.evaluationValueReceived.personStudentId, 
        age:this.group.groupPerson.personStudent.age, 
        subjectId:exam,
        userCreated: this.User.email
      }
      baseInstanceAxios
					.post(this.API_URL + `/Resources/GroupsPersonsEvaluations/SendEvaluation`, evalutionExecute)
					.then(response => {
						if ( response.data != null && response.data.return ) {
              var personStudentId = this.evaluationValueReceived.personStudentId;
              this.evaluationValueReceived = response.data.entity;
              this.evaluationValueReceived.personStudentId= personStudentId;
              this.group.groupPerson.personStudent.levelId = this.evaluationValueReceived.level.id;
              this.$forceUpdate();
						}
					})
          .catch(function (error) {
              console.log(error);
              
          });;
    },
    courseValueChild(data) {
      this.group.groupCourses = data;
    }
  },
 
}
</script>